import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDhc7iUzi6Dkchyr-gfmNvgMP3MJ0A-KZE",
  authDomain: "moventa-edc7e.firebaseapp.com",
  projectId: "moventa-edc7e",
  storageBucket: "moventa-edc7e.firebasestorage.app",
  messagingSenderId: "968694037265",
  appId: "1:968694037265:web:f0a47aef31d1a184f4eab0",
  measurementId: "G-BE93PKE9ZJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;
